import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({
  dataComponents: {
    footer: { backgroundColor, boxShadow },
  },
}: ComposedTheme) => ({
  root: {
    backgroundColor,
    boxShadow,
    margin: 0,
    padding: [12, 20],
    position: 'relative',
    width: '100%',
    '@media print': {
      display: 'none',
    },
  },
  sticky: {
    bottom: 0,
    left: 0,
    position: 'sticky',
  },
});

export default createUseStyles(styles);
